import { useResponsive } from 'hooks/useResponsive'

export default function useIsMobile() {
  const [match] = useResponsive()
  return !!(match.xxs || match.xs)
}
